module.exports = __webpack_public_path__ + "static/media/sub_menu_skincare_pro_pink.d45de636.png";